import { types } from "../types/types";


export const renameRole = (name) =>{
    let roleName = '';
    for(let type in types){
        if((types[type].pseudoName === name)) return  types[type].name;
    }
    return roleName;
}